import * as _ from 'lodash';

/**
 * This function converts a percentage value into a decimal.
 *
 * @example parsePercentageAsDecimal(25) => 0.25
 * @example parsePercentageAsDecimal(100) => 1.0
 * @param {number} val - The percentage value to be converted.
 * @param {number} precision - The number of decimal places to round the result to. Default is 3.
 * @returns {number} - The decimal representation of the input percentage.
 */
export function parsePercentageAsDecimal(val: number, precision = 3): number {
  let decimalPercent = _.toNumber(val);
  decimalPercent /= 100;
  decimalPercent = Number.parseFloat(decimalPercent.toFixed(precision));
  return decimalPercent;
}

/**
 * This function converts a decimal value into a percentage.
 *
 * @example formatDecimalAsPercentage(0.25) => 25
 * @example formatDecimalAsPercentage(1.0) => 100
 * @param val - The decimal value to be converted.
 * @returns - The percentage representation of the input decimal.
 */
export function formatDecimalAsPercentage(val: number): number {
  // going to be 1.0 or 0.8, we want to convert to 100 or 80
  let percentage = _.toNumber(val);
  percentage *= 100;
  percentage = Number.parseFloat(percentage.toFixed(0));
  return percentage;
}
